import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { documentDraftDeleted, documentDraftSnoozed } from "store/actions/documentDraftActions";
//#endregion
//#region types
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
import { ACTION_SEPARATOR, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { AuthEnums, StyleEnums, DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DocumentDraftMoreActionProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { MoreActions, useSnoozeAction } from "components/common";
import { useDocumentDraftService } from "serviceHooks";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentDraftMoreActions: React.FC<DocumentDraftMoreActionProps> = (props) => {
  const documentDraftService = useDocumentDraftService();
  const dispatch = useDispatch();

  //#region snooze
  const onSnoozeSuccess = () => {
    dispatch(documentDraftSnoozed(props.documentDraft.id));
    props.markAsDoneHandler && props.markAsDoneHandler();
  };

  const { snoozeAction } = useSnoozeAction(
    props.documentDraft.id,
    ApiModel.TodoType.DocumentDraft,
    onSnoozeSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SubmittedDocument)
  );
  //#endregion

  //#region delete document draft
  const onClickDelete = () => {
    return documentDraftService.deleteDocumentDraft(props.documentDraft.id);
  };

  const onDeleteSuccess = () => {
    dispatch(documentDraftDeleted(props.documentDraft.id));
    props.markAsDoneHandler && props.markAsDoneHandler();
  };

  const cancelInvoiceAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
    icon: IconDefinitionConstants.WTrashAlt,
    actionDialog: {
      isOpen: false,
      title: `${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Discard
      )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SubmittedDocument)}?`,
      titleIcon: IconDefinitionConstants.WTrashAlt,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          onClick: onClickDelete,
          type: StyleEnums.DisplayType.Danger,
          successMessage: TranslationKeys.DocumentDraft.CancelSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Message,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DeleteWarningMessage),
      type: StyleEnums.DisplayType.Danger,
    },
    highlightType: StyleEnums.DisplayType.Danger,
    onActionSuccess: onDeleteSuccess,
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    if (!CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor)) {
      actions.push(snoozeAction);
      actions.push(ACTION_SEPARATOR);
      actions.push(cancelInvoiceAction);
    }
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default DocumentDraftMoreActions;
